module.exports = {"410108001":"新城街道","410108002":"刘寨街道","410108003":"江山路街道","410108004":"长兴路街道","410108005":"迎宾路街道","410108006":"大河路街道","410108100":"花园口镇","410108101":"古荥镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410108.json
// module id = 1518
// module chunks = 0